import { render, staticRenderFns } from "./division-breakdown.vue?vue&type=template&id=00845f52&"
import script from "./division-breakdown.vue?vue&type=script&lang=ts&"
export * from "./division-breakdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports